import { getLogicNodeSchema, getLogicPalette } from '../Hasp/properties/v2/logic/index.js';
import LogicGraphCommand from '../history/commands/LogicGraphCommand.js';
import { canConnect, connect, createLogicGraph, validateLogicGraph } from './logicGraph.js';
import { createLogicNode } from './logicNodeFactory.js';
import { planPaletteNode } from './logicPlacement.js';
import { createPageLogicContext } from './pageLogic.js';
import { withSubjectTrigger } from './subjectTrigger.js';

/**
 * The event/action node graph as a canvas graph domain: what the generic
 * graph store (stores/graphStoreOptions.js) needs to edit `page.logic`.
 */
export const logicDomain = Object.freeze({
    graphKey: 'logic',
    mode: 'logic',
    noun: 'logic',
    createGraph: createLogicGraph,
    createNode: createLogicNode,
    getNodeSchema: getLogicNodeSchema,
    getPalette: getLogicPalette,
    planPaletteNode,
    // A GPIO State wired to a comparison brings its trigger events along.
    connect: (graph, from, to, context) => withSubjectTrigger(connect(graph, from, to, context), context),
    canConnect,
    validate: validateLogicGraph,
    createContext: createPageLogicContext,
    createCommand: options => new LogicGraphCommand(options),
});
